import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Page from "../../components/table/paging";
import { FormProps } from "../../components/form/interface/formInterface";
import InputFormStyle from "../../components/style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import { ISocialUser } from "./interface/interface";
import GAMEAPI from "../../api/game";
import SmallForm from "../../components/form/small_form";
import SocialTable from "../../components/table/SocialTable";
import SearchSenderUser from "./component/SearchSenderUser";
import FormSelect from "../../components/form/form_select";

interface ClubListDto {
  name: string;
  clubId: number;
}

const Socail = () => {
  const limit = 10;
  const [total, setTotal] = useState(0);
  const [userList, setUserList] = useState<ISocialUser[]>([]);
  const [message, setMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSenderSearch, setIsSenderSearch] = useState<boolean>(false);
  const [searchNickname, setNickname] = useState("");
  const [selectedClub, setSelectedClub] = useState<string>("전체");
  const [senderUserId, setSenderUserId] = useState<number>(0);
  const [senderUserNickname, setSenderUserNickname] = useState<string>("");
  const [selectedList, setSelectedList] = useState<
    {
      id: number;
      nickname: string;
    }[]
  >([]);
  const [mode, setMode] = useState("U");
  const [clubList, setClubList] = useState<ClubListDto[]>([]);
  const [isSending, setIsSending] = useState(false);

  const formData: FormProps = {
    title: "메시지 전송",
    form: [
      {
        value: senderUserNickname,
        setValue: setSenderUserNickname,
        label: "유저",
        width: "100%",
        isOpen: isSenderSearch,
        setIsOpen: setIsSenderSearch,
        type: "search-group",
      },
      {
        value: message,
        setValue: setMessage,
        label: "메시지 내용",
        width: "100%",
        type: "input",
      },
      {
        value: selectedList.map((item) => item.nickname).join(", "),
        setValue: setSelectedList,
        label: "수신 유저 닉네임",
        width: "100%",
        type: "text",
        disabled: true,
      },
    ],
  };

  const headers = [
    {
      text: "",
      align: "center",
      sortable: false,
      value: "",
    },
    {
      text: "ID",
      align: "center",
      sortable: false,
      value: "userId",
    },
    {
      text: "닉네임",
      align: "center",
      sortable: false,
      value: "nickname",
    },
    {
      text: "가입 클럽",
      align: "center",
      sortable: false,
      value: "club",
    },
  ];

  useEffect(() => {
    getUserList();
  }, [currentPage]);

  useEffect(() => {
    getClubData();
  }, []);

  const getClubId = (value: string) => {
    const club = clubList.find((item) => item.name.trim() === value.trim());
    if (club) return club.clubId;
    return -1;
  };

  const getClubData = async () => {
    const club = await GAMEAPI.getClubList(1, 1000);

    if (club.data.result === 1 && club.data.payload) {
      const clubData = club.data.payload.clubs;
      const list = [];
      list.push({
        name: "전체",
        clubId: -1,
      });
      list.push(...clubData);
      setClubList(list);
    }
  };

  const getUserList = async () => {
    const clubId = getClubId(selectedClub);
    try {
      const response = await GAMEAPI.getGameUserList(
        currentPage - 1,
        limit,
        searchNickname,
        clubId === -1 ? null : clubId
      );

      if (response.data.result === 1) {
        const userData = response.data.users;
        const totalPages = Math.ceil(response.data.totalCount / limit);
        setTotalPages(totalPages);
        setUserList(userData);
        setTotal(response.data.totalCount);
      }
    } catch (error) {
      console.error("유저 정보 로드 실패:", error);
    }
  };

  const handleSearch = async () => {
    setCurrentPage(1); // 검색 시 첫 페이지로
    getUserList();
  };

  useEffect(() => {
    handleSearch();
  }, [selectedClub]);

  const sendMessage = async () => {
    if (!senderUserId || isSending) {
      return;
    }
    setIsSending(true);
    const receiverUserIds = selectedList.map((item) => item.id);
    const res = await GAMEAPI.sendGameMessage(
      senderUserId,
      receiverUserIds,
      message
    );

    if (res.data.result === 1) {
      alert("전송되었습니다");
      setIsSending(false);
      setSelectedList([]);
      setMessage("");
      setNickname("");
      setSenderUserId(-1);
      setSenderUserNickname("");
    } else {
      alert("전송 중 오류가 발생하였습니다.");
      setIsSending(false);
    }
  };

  const handleSelectedUsers = async () => {
    const clubId = getClubId(selectedClub);
    const totalPages = Math.ceil(total / 200);
    const userDataList = [];
    for (let i = 0; i < totalPages; i++) {
      const response = await GAMEAPI.getGameUserList(
        i,
        200,
        searchNickname,
        clubId === -1 ? null : clubId
      );
      const userData = response.data.users;
      userDataList.push(...userData);
    }
    const list = userDataList.map((item) => {
      return { id: item.userId, nickname: item.nickname };
    });
    setSelectedList(list);
  };

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          전체 쪽지 전송
        </h2>

        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="20px"
          marginBottom="10px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="end"
            align_items="flex-end"
            gap="30px"
          >
            <FormSelect
              options={clubList}
              value={selectedClub}
              label={""}
              setValue={setSelectedClub}
              width="20%"
            ></FormSelect>
            {/* 검색 */}
            <DivStyle
              width="50%"
              display="flex"
              justify_content="flex-end"
              flex_direction="row"
              align_items="center"
              marginRight="20px"
              marginTop="20px"
            >
              <InputFormStyle
                onChange={(e) => setNickname(e.target.value)}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              ></InputFormStyle>
              <div onClick={() => handleSearch()}>
                <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
              </div>
            </DivStyle>
            {/* 전체 유저 선택 */}
            <button
              onClick={handleSelectedUsers}
              style={{
                padding: "8px 12px",
                borderRadius: "5px",
                border: "1px solid #666",
                backgroundColor: "#4A4A4A",
                color: "white",
                cursor: "pointer",
                fontSize: "12px",
                marginLeft: "-20px",
                marginRight: "25px",
              }}
              onMouseOver={(e) =>
                ((e.target as HTMLElement).style.backgroundColor = "#5A5A5A")
              }
              onMouseOut={(e) =>
                ((e.target as HTMLElement).style.backgroundColor = "#4A4A4A")
              }
            >
              검색된 전체 유저 선택
            </button>
          </DivStyle>
          <SocialTable
            headers={headers}
            dataList={userList}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={userList}
            total={total}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          메시지 전송
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            mode={mode}
            add={sendMessage}
          />
        </DivStyle>
      </DivStyle>
      {isSenderSearch && (
        <SearchSenderUser
          setSenderUserNickname={setSenderUserNickname}
          setSenderUserId={setSenderUserId}
          setIsOpen={setIsSenderSearch}
        />
      )}
    </DivStyle>
  );
};

export default Socail;
